export const eventOptions = {
	passive: true,
	once: true,
	capture: true
};
